export default "__VITE_ASSET__vcF2jqOH__"